import authSession from "../../lib/authSession";
import { API_URL } from "../../constants";
import { safeFetch, explainApiError } from "../../utils/toDisplayString";

export const resourcePersonDashboardInitialState = {
  dashboard: null,
  dashboardLoading: false,
  dashboardError: null,
};

function dashboardUrl() {
  if (!API_URL) throw new Error("REACT_APP_API_BASE_URL is not configured.");
  return `${API_URL.replace(/\/$/, "")}/api/resource-person/dashboard`;
}

async function fetchDashboardData() {
  const token = authSession.getToken();
  const headers = { Accept: "application/json" };
  if (token) headers.Authorization = `Bearer ${token}`;
  const response = await safeFetch(dashboardUrl(), {
    headers,
    credentials: "omit",
  });
  const text = await response.text();
  const contentType = response.headers.get("content-type") || "";
  let data = {};
  if (text) {
    if (contentType.includes("application/json")) data = JSON.parse(text);
    else if (text.trim().startsWith("<")) throw new Error(`Resource person dashboard API returned HTML (${response.status}) from ${dashboardUrl()}.`);
    else data = JSON.parse(text);
  }
  if (!response.ok || data.error || data.success === false) {
    const apiError = data.error?.message || data.error || data.message;
    throw new Error(explainApiError(response.status, data || {}, `Resource person dashboard request failed with status ${response.status}.`));
  }
  return data?.data && typeof data.data === "object" ? data.data : data;
}

export function createResourcePersonDashboardActions(set) {
  return {
    fetchDashboard: async () => {
      set({ dashboardLoading: true, dashboardError: null });
      try {
        const dashboard = await fetchDashboardData();
        set({ dashboardLoading: false, dashboard, dashboardError: null });
        return { success: true, dashboard };
      } catch (error) {
        set({ dashboardLoading: false, dashboardError: error.message, dashboard: null });
        return { success: false, error: error.message };
      }
    },
  };
}
